//autoWidthSize
import { useEffect, useState } from 'react';
import { throttle } from '../helpers/throttle';

// const useResizeWindows = () => {
//   const [width, setWidth] = useState(window.innerWidth);
//   const handleResize = (e) => setWidth(window.innerWidth);
//   useEffect(() => {
//     window.addEventListener('resize', handleResize);
//     return () => {
//       window.removeEventListener('resize', handleResize);
//     };
//   }, []);
//   return width;
// };

// export default useResizeWindows;

const useResizeWindows = (throttleDelay = 150) => {
  const [width, setWidth] = useState(window.innerWidth);

  const handleResize = throttle((e) => {
    setWidth(window.innerWidth)
  }, throttleDelay);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [throttleDelay]);
  
  return width;
};

export default useResizeWindows;
